export default __webpack_public_path__ + "static/media/bomj.e8f4cacd.jpeg";